import clsx from 'clsx';
import CheckIcon from '../../assets/icons/check-icon.svg?react';
import React, { ReactNode } from 'react';
interface CheckboxProps {
  otherClasses?: string;
  name: string;
  errorMessage?: string;
  checked: boolean;
  disabled?: boolean;
  label?: string | ReactNode;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: any) => void;
  'aria-label'?: string;
  'aria-describedby'?: string;
}

const Checkbox: React.FC<CheckboxProps> = ({
  otherClasses,
  name,
  onChange,
  onBlur,
  errorMessage = '',
  checked,
  disabled,
  label,
  'aria-label': ariaLabel,
  'aria-describedby': ariaDescribedby,
}) => {
  const checkboxClasses = clsx(
    otherClasses,
    'flex items-start gap-1.5 relative cursor-pointer select-none ',
    disabled && `cursor-not-allowed`,
  );

  const errorId = `${name}-error`;

  return (
    <label
      htmlFor={name}
      data-testid="checkbox"
      className={checkboxClasses}
      aria-invalid={errorMessage !== ''}
    >
      <input
        disabled={disabled}
        type="checkbox"
        className="peer absolute top-0 left-0 opacity-0"
        id={name}
        onBlur={onBlur}
        checked={checked}
        name={name}
        onChange={(e) => !disabled && onChange(e)}
        aria-label={ariaLabel}
        aria-describedby={errorMessage ? errorId : ariaDescribedby}
        tabIndex={disabled ? -1 : 0}
      />
      <span
        className={clsx(
          'relative h-4 min-h-4 w-4 min-w-4 overflow-hidden rounded-xs ring-2',
          disabled
            ? `ring-neutral-tones-text/35 cursor-not-allowed`
            : errorMessage !== ''
              ? 'ring-brand-posh-pink'
              : 'ring-neutral-tones-text text-brand-byzantine',
        )}
        role="presentation"
        aria-hidden="true"
      >
        {checked && (
          <CheckIcon className="[&>path]:fill-neutral-tones-text absolute top-2/4 left-2/4 w-5 -translate-x-2/4 -translate-y-2/4" />
        )}
      </span>
      <p
        className={clsx(
          'text-form-label font-inter-variable peer-focus:text-brand-byzantine font-normal select-none',
          disabled
            ? `text-neutral-tones-text/35 cursor-not-allowed`
            : errorMessage !== ''
              ? `text-brand-posh-pink`
              : `text-neutral-tones-text`,
        )}
      >
        {label}
      </p>
      {errorMessage !== '' && (
        <span
          id={errorId}
          className="font-inter-variable text-brand-posh-pink absolute -bottom-6 left-0 text-xs font-normal"
          role="alert"
        >
          {errorMessage}
        </span>
      )}
    </label>
  );
};
export default Checkbox;
